import React from "react";
import './Background.scss';

function Background({isClassicMode}) {
  const bokehCount = 20;
  const bokeh = [...Array(bokehCount).keys()];

  const backgroundURL = `${process.env.PUBLIC_URL}./assets/${isClassicMode ? 'background' : 'background_deluxe'}.jpg?${Date.now()}`;

  return <div className="background">
    {
      bokeh.map(index => <span key={index}/>)
    }
    <img src={backgroundURL} alt=''/>
  </div>
}

export default Background;
